import { Form, FormikProvider, useFormik } from 'formik';
import React from 'react';
import { Box } from '@material-ui/core';
import { useEafFormStyles } from '../EafFormShared/useEafFormStyles';
import { sidebarFormStyles } from '../../../employeeActionsForm/components/EndAssignment/styles';
import NumberField from '../../../../shared/components/formFields/NumberField';
import { EafSubmitBlock } from '../EafFormShared/EafSubmitBlock';

export interface IPlacementChangeFormProps {
    onSubmit: (values: any) => void;
    onCancel: () => void;
    isLoading: boolean;
    aviontePlacementId?: string;
}

export function PlacementChangeForm({
    onSubmit,
    onCancel,
    isLoading,
    aviontePlacementId,
} : IPlacementChangeFormProps) {
    const classes = useEafFormStyles();
    const formClasses = sidebarFormStyles();
    const formikData = useFormik({
        initialValues: {
            placementId: aviontePlacementId,
        },
        onSubmit,
    });
    return (
        <FormikProvider value={formikData}>
            <Form>
                <Box className={classes.row}>
                    <label htmlFor="effectiveDate" className={formClasses.inlineInputLabel}>New Placement ID:</label>
                    <Box width="130px">
                        <NumberField
                            name="placementId"
                            className={formClasses.input}
                        />
                    </Box>
                </Box>
                <Box>
                    <EafSubmitBlock
                        isLoading={isLoading}
                        onCancel={onCancel}
                    />
                </Box>
            </Form>
        </FormikProvider>
    );
}
